import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-X3-logo_svg__Ebene_1",
  "data-name": "Ebene 1",
  viewBox: "0 0 289.94 231.95"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-X3-logo_svg__cls-1{fill:#e41917}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M13.77 64.62h68.92c6.76 0 11.85 2.14 13.85 11.73 2.23 10.67 1.31 18.1-10.7 18.95L64.2 96.84c15.93 100.63 109.04 133.43 159.74 25.05 8.39-17.94 11.14-21.21 20.33-18.92 12.46 3.09 14.16 9.5 8.23 27.58-43.83 133.61-191.16 147-220.06-31.42l-17.58 1.27C.56 101.42 0 89.35 0 82.64c0-13.27 4.93-18.02 13.77-18.02M264.36 0c14.13 0 25.58 11.45 25.58 25.58s-11.45 25.58-25.58 25.58-25.58-11.45-25.58-25.58C238.78 11.45 250.24 0 264.36 0",
      class: "svg-X3-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "X3-logo"}) } }